























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _, { drop } from 'lodash';
import { mapFields } from 'vuex-map-fields';
import { Product} from '@/models/product';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import Pica from 'pica';
import { asyncForEach } from '@/utils';

@Component({
    name: 'product-gallery',
    components: {
        showFilesModal,
    },
    computed: {
        ...mapState('webInventory', ['activeProductLoading', 'cacheProducts', 'cacheProductsLoading']),
        ...mapFields({
            activeProduct: 'webInventory.activeProduct',
        }),
        ...mapState('productBrands', ['allProductBrands']),
        ...mapState('productCategories', ['allProductCategories']),
        ...mapState('productSectors', ['allProductSectors']),
        ...mapState('productApplications', ['allProductApplications']),
    },
})
export default class StoreProductDetailModal extends Vue {
    //
    public activeProduct!: Product;
    private activeProductLoading!: boolean;
    private cacheProducts!: any;
    public allProductCategories!: any;
    public allProductBrands!: any;
    public allProductSectors!: any;
    public allProductApplications!: any;

    private showTypeahead: boolean = false;

    private searchQuery: string = '';
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_order: any = [];
    public fields_product_order: any = ['sku', 'qty', 'price'];

    // public imageProductContainer: any = null;
    // public imageProductContainerData: any = null;

    public file_type: any = '';
    resizedImage: any = null;

    // mainImage: string = this.activeProduct.gallery[0];
    draggedImageIndex: number | null = null;

    setFileType(file_type: string) {
        this.file_type = file_type;
    }

    async onFileChange(e: any) {
        console.log("HOla84");
        console.log(e);
        
        
        switch (this.file_type) {
            case 'gallery':
                if (e.target) {
                    const files = e.target.files;
                    console.log();
                    
                    // await files.forEach(async (file: any) => {
                    await asyncForEach(files, async (file: any) => {
                        if (!file) return;
                        try {
                            this.activeProduct.gallery.push(this.formatFile(file, '', ''));
                            let dinamic_width = 150;
                            let dinamic_height = 150;
                            // convert original file to webp
                            const resizedFile: any = await this.resizeImage(file, 0, 0);
                            this.activeProduct.complete_gallery.push(this.formatFile(resizedFile, 0, 0));
                            console.log(this.formatFile);
                            do {
                                const resizedFile: any = await this.resizeImage(file, dinamic_width, dinamic_height);
                                this.activeProduct.complete_gallery.push(this.formatFile(resizedFile, dinamic_width, dinamic_height));
                                dinamic_width += 650;
                                dinamic_height += 650;
                            } while (dinamic_width <= 800);
                        } catch (error) {
                            console.error('Error resizing image:', error);
                        }
                        // });
                        // console.log(this.activeProduct.complete_gallery);
                        // // console.log({ data: URL.createObjectURL(file) });
                        // let formData = new FormData();
                        // formData.append('image', file, file.name);
                        // this.activeProduct.gallery = [
                        //     ...this.activeProduct.gallery,
                        //     {
                        //         id: uuidv4(),
                        //         sort: null,
                        //         url: URL.createObjectURL(file),
                        //         origin: 'upload',
                        //         file: formData,
                        //         name: file.name,
                        //     },
                        // ];
                    });
                } else {
                    this.activeProduct.gallery = [
                        ...this.activeProduct.gallery,
                        {
                            id: e.id,
                            sort: null,
                            url: `https://directus.prodelec.app/assets/${e.id}`,
                            // url: `http://localhost:8055/assets/${e.id}`, // Este es cuando se quieren hacer pruebas con la BD de desarrollo 
                            origin: 'directus-update',
                            file: null,
                        },
                    ];
                }
            default:
                console.log('Img progress...');
                // console.log('getting img from existing file');
                break;
        }
    }

    onRemoveImg(index: any) {
        if (this.activeProduct.gallery[index].hasOwnProperty('name')) {
            let title = this.activeProduct.gallery[index].name;
            title = title.split('_')[0];
            _.remove(this.activeProduct.complete_gallery, function (file) {
                return file.name.includes(title);
            });
            this.activeProduct.gallery.splice(index, 1);
        } else {
            this.activeProduct.gallery.splice(index, 1);
        }
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    async handleFileChange(event: any) {
        //working with many files
        const files = event.target.files;
        let files_to_upload = [];
        await asyncForEach(files, async (file: any) => {
            if (!file) return;
            try {
                files_to_upload.push(this.formatFile(file, '', ''));
                let dinamic_width = 150;
                let dinamic_height = 150;
                // convert original file to webp
                const resizedFile: any = await this.resizeImage(file, 0, 0);
                files_to_upload.push(this.formatFile(resizedFile, 0, 0));
                do {
                    const resizedFile: any = await this.resizeImage(file, dinamic_width, dinamic_height);
                    files_to_upload.push(this.formatFile(resizedFile, dinamic_width, dinamic_height));
                    dinamic_width += 650;
                    dinamic_height += 650;
                } while (dinamic_width <= 800);
                // console.log({ files_to_upload });

                // this.$store.dispatch('webInventory/postFile', { data: files_to_upload });
            } catch (error) {
                console.error('Error resizing image:', error);
            }
        });
    }

    resizeImage(file: any, width: any, height: any) {
        return new Promise((resolve, reject) => {
            const pica = new Pica();
            const img = new Image();
            img.onload = async () => {
                try {
                    if (img.width >= 1500 && img.height >= 1500) {
                        const resizedCanvas = document.createElement('canvas');
                        width == 0 ? (resizedCanvas.width = img.width) : (resizedCanvas.width = width);
                        height == 0 ? (resizedCanvas.height = img.height) : (resizedCanvas.height = height);
                        const resizeOptions = {
                            filter: 'mks2013',
                        };
                        // console.log('Dimensiones originales width: ', img.width, ' height: ', img.height);
                        // console.log('Dimensiones actualizadas width: ', resizedCanvas.width, ' height: ', resizedCanvas.height);
                        await pica.resize(img, resizedCanvas, resizeOptions);
                        // const resizedDataURL = resizedCanvas.toDataURL('image/jpeg');
                        resizedCanvas.toBlob((blob) => {
                            const resizedFile = new File([blob], file.name, { type: 'image/webp' });
                            // const resizedFile = new File([blob], file.name, { type: 'image/jpeg' });
                            resolve(resizedFile);
                        }, 'image/webp');
                        // }, 'image/jpeg');
                    } else {
                        this.activeProduct.gallery.pop();
                        this.$bvToast.toast('Lo sentimos, la imagen no cumple con las dimensiones mínimas (1500x1500)', {
                            title: `Imagen no válida`,
                            variant: 'warning',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 5000,
                        });
                        return false;
                    }
                } catch (error) {
                    reject(error);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    }

    formatFile(resizedFile: any, width: any, height: any) {
        let file_name = resizedFile.name.split('.')[0];
        file_name = file_name + '_' + width + 'x' + height;
        let formData = new FormData();
        formData.append('title', file_name);
        formData.append('image', resizedFile, resizedFile.name);
        return {
            id: uuidv4(),
            sort: null,
            url: URL.createObjectURL(resizedFile),
            origin: width && width > 0 ? 'resize' : 'upload',
            file: formData,
            name: file_name,
        };
    }

    // Se ejecuta al iniciar el arrastre de la imagen
    onDragStart(event: DragEvent, index: number) {
        this.draggedImageIndex = index;
        event.dataTransfer?.setData('text/plain', String(index));
    }

    // Prevenir el comportamiento por defecto para permitir el drop
    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    // Se ejecuta cuando se suelta una imagen
    onDrop(event: DragEvent, dropIndex: number) {
        // Prevenir el comportamiento predeterminado del evento de arrastre y soltado
        event.preventDefault();
         // Verificar si hay una imagen que se esté arrastrando (el índice de la imagen arrastrada no es nulo)
        if (this.draggedImageIndex !== null) {
            // Verificar que la imagen no se esté soltando en el mismo índice del que fue arrastrada
            if (this.draggedImageIndex !== dropIndex) {
                // Remover la imagen arrastrada de su posición original en la galería
                const draggedImage = this.activeProduct.gallery.splice(this.draggedImageIndex, 1)[0];
                // Insertar la imagen arrastrada en la nueva posición (índice de soltado)
                this.activeProduct.gallery.splice(dropIndex, 0, draggedImage);
                this.activeProduct.gallery[dropIndex] = draggedImage;
            }
        }
         // Restablecer el índice de la imagen arrastrada a null para indicar que se completó la operación
        this.draggedImageIndex = null; 
    }
}
